/**
 * Helper component that lests users select items from a simple array
 *
 * NOTE: To use -
 *
 * render() {
 *   var things = ["Thing One", "Thing Two", "Thing Three"];
 *   return (
 *     <div>
 *       <SelectFromArray
 *         items={things}
 *         change={this._onSelectChange}
 *         value={"Thing One"} //- optional
 *         placeholder="-- Select a Thing -- "
 *       />
 *     </div>
 *   )
 * }
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';
import FilterableSelect from 'react-select';

// import components
import Base from "../BaseComponent.js.jsx";

class SelectFromArray extends Base{
  constructor(props) {
    super(props);
    this.state = {
      selected: props.value || ''
    }
    this._bind(
      '_handleSelectChange'
      , '_capitalizeFirstLetter'
    );
  }

  // check against any new props the component receives
  componentWillReceiveProps(nextProps) {
    if(this.props.value != nextProps.value){
      this.setState({selected: nextProps.value});
    }
  }

  _capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  _handleSelectChange(e) {
    const { change, filterable, name } = this.props;
    if(filterable) {
      let event = {target: {}};
      event.target.name =  name;
      event.target.value = e ? e.value : null;
      this.setState({
        selected: e ? e.value : null
      });
      change(event);
    } else {
      this.setState({
        selected: e.target.value
      });
      change(e);
    }
  }

  render() {
    const {
      capitalize
      , clearable
      , disabled
      , filterable
      , helpText
      , includePlaceholder
      , items
      , label
      , name
      , placeholder
      , required
    } = this.props;

    // build the items to select from
    let theItems = items.map((item, index) => {
      let display = capitalize ? _.startCase(item) : item;
      return (
        <option key={index} value={item}>
          {display}
        </option>
      )
    });

    const filterableOptions = items.map((item, i) => {
      let fOption = {}
      fOption.value = item;
      fOption.label = capitalize ? _.startCase(item) : item;
      fOption.name = name;
      fOption.clearableValue = false;
      return fOption;
    })

    // render placeholder
    if(placeholder && includePlaceholder) {
      var placeholderText = <option key="-1" value={''}>{placeholder}</option>;
      theItems.unshift(placeholderText);
    }

    return (
      <div className="form-group-select input-group">
        <label htmlFor={name}>{label} {required ? <sup className="-required">*</sup> : null}</label>
        { filterable ?
          <FilterableSelect
            clearable={clearable}
            isDisabled={disabled}
            name={name}
            onChange={this._handleSelectChange}
            options={filterableOptions}
            placeholder={placeholder}
            required={required}
            value={this.state.selected}
          />
          :
          <select
            name={name}
            onChange={this._handleSelectChange}
            required={required}
            value={this.state.selected}
            disabled={disabled}
            >
            {theItems}
          </select>
        }
        <small className="help-text"><em>{helpText}</em></small>
      </div>
    )
  }
}

SelectFromArray.propTypes = {
  change: PropTypes.func.isRequired
  , clearable: PropTypes.bool
  , disabled: PropTypes.bool
  , filterable: PropTypes.bool
  , helpText: PropTypes.any
  , includePlaceholder: PropTypes.bool
  , items: PropTypes.array.isRequired
  , label: PropTypes.string
  , placeholder: PropTypes.string
  , required: PropTypes.bool
  , value: PropTypes.any.isRequired
  , capitalize: PropTypes.bool
}

SelectFromArray.defaultProps = {
  clearable: false
  , disabled: false
  , filterable: false
  , helpText: null
  , includePlaceholder: true
  , label: ''
  , placeholder: '-- Select from the following --'
  , required: false
  , capitalize: true
}

export default SelectFromArray;



// WEBPACK FOOTER //
// global/components/forms/SelectFromArray.js.jsx